"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _csrf = require("@insided/shared/utils/csrf");

var _constants = require("../constants");

var _effects = require("../effects");

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'follow-user';
exports.cssAnchorName = cssAnchorName;

var counterSelector = function counterSelector() {
  var _globalThis$location;

  return (_globalThis$location = globalThis.location) !== null && _globalThis$location !== void 0 && _globalThis$location.href.includes('/network/followers') ? _constants.FOLLOWING_COUNTER_SELECTOR : _constants.FOLLOWERS_COUNTER_SELECTOR;
};

var followUrl = function followUrl(id) {
  return (0, _absoluteUrlRuntime.resolveUrl)("/network/follow?connectionid=".concat(id));
};

var unfollowUrl = function unfollowUrl(id) {
  return (0, _absoluteUrlRuntime.resolveUrl)("/network/unfollow?connectionid=".concat(id));
};

var FollowUser = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FollowUser, _Component);

  var _super = _createSuper(FollowUser);

  function FollowUser() {
    var _this;

    (0, _classCallCheck2.default)(this, FollowUser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isFollowing: _this.props.isFollowing,
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var connectionId, url, body;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();

                if (!_this.state.isLoading) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                connectionId = _this.props.connectionId;
                url = _this.state.isFollowing ? unfollowUrl(connectionId) : followUrl(connectionId); // Bust the per-toggle CSRF nonce so repeated toggles never replay.

                body = new URLSearchParams((0, _csrf.withCsrf)({
                  _: Date.now()
                }));

                _this.setState({
                  isLoading: true
                });

                _context.prev = 8;
                _context.next = 11;
                return _axios.default.post(url, body);

              case 11:
                _this.setState(function (prev) {
                  return {
                    isFollowing: !prev.isFollowing,
                    isLoading: false
                  };
                }, function () {
                  return (0, _effects.mutateCounter)(counterSelector(), _this.state.isFollowing ? 1 : -1);
                });

                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](8);

                _this.setState({
                  isLoading: false
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 14]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(FollowUser, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          connectionId = _this$props.connectionId,
          extraClass = _this$props.extraClass;
      var _this$state = this.state,
          isFollowing = _this$state.isFollowing,
          isLoading = _this$state.isLoading;
      var href = isFollowing ? unfollowUrl(connectionId) : followUrl(connectionId);
      var className = (0, _classnames.default)('btn--toggle', 'toggle-follow', extraClass, {
        'is-follow': isFollowing,
        'is-loading': isLoading
      });
      return (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(href),
        class: className,
        onClick: this.handleClick
      }, (0, _preact.h)("span", {
        class: (0, _classnames.default)('unfollow', {
          'is-hidden': !isFollowing
        })
      }, (0, _preact.h)(_phrase.default, {
        p: "Following",
        renderAsText: true
      })), (0, _preact.h)("span", {
        class: (0, _classnames.default)('follow', {
          'is-hidden': isFollowing
        })
      }, (0, _preact.h)(_phrase.default, {
        p: "Follow user",
        renderAsText: true
      })), (0, _preact.h)("span", {
        class: "loader"
      }));
    }
  }]);
  return FollowUser;
}(_preact.Component);

exports.default = FollowUser;